import React, { useEffect, useState, useLayoutEffect, Fragment, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  EDIT_FROM,
  PO_EDIT_MODE,
  QS_CONSTANT
} from '../../define/global';
import {
  NAVERWORKS_DRIVE_TYPE,
  NAVERWORKS_NAVIGATOR_TYPE,
  NAVERWORKS_ROOT_FOLDER_NAME
} from '../../define/naverworksDefine';
import {
  getNaverWorksFolderChildren,
  getNaverWorksRootFolder,
  getNaverWorksTokenInfo,
  getReauthorizationUrl,
  reauthorizationNaverWorks
} from '../../extApis/naverWorksApi';
import { closeDialog, openDialog } from '../../store/modules/dialog';
import Dialog from './Dialog';
import closeBtnImg from '../../img/dlg-close.png';
import { useRef } from 'react';
import { closeContextMenu, openContextMenu } from '../../store/modules/contextMenu';
import ContextMenuFolderPath from '../contextMenu/ContextMenuFolderPath';
import IconPath from '../../img/dlg_path.png';
import IconPath2X from '../../img/dlg_path@2x.png';
import IconMore from '../../img/dlg_path_more.png';
import IconMore2X from '../../img/dlg_path_more@2x.png';
import IconRefresh from '../../img/dlg_refresh.png';
import IconRefresh2X from '../../img/dlg_refresh@2x.png';
import IconNaverWorks from '../../img/ribbon_big_ico_naver_works drive.png';
import IconNaverWorks2X from '../../img/ribbon_big_ico_naver_works drive@2x.png';
import { NaverWorksError } from '../../errors';
import NaverWorksFileNavigator from '../naverWorks/NaverWorksFileNavigator';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import {
  isDevicePC,
  useGetHomeURLWithProductType,
  useOpenNewTabWithQueryinSameDomain
} from '../../utils/util';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import {
  getExtension,
  getFileFormat,
  useDoFlowByCheckingResult
} from '../../utils/FileControlUtil';
import { setEditMode, setFileName } from '../../store/modules/docInfo';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import ga from '../../utils/gaConnect';
import { useWhaleSpaceDataSliceSelector } from '../../store/modules/whaleSpaceData';
import { Trans, useTranslation } from 'react-i18next';
import {
  initNaverWorksData,
  setNaverWorksData,
  setNaverWorksFileInfo,
  useNaverWorksDataSliceSelector
} from '../../store/modules/naverWorksData';
import CONSTANT from '../../define/constant';
import { noTextSelect } from '../common/CssCommon';
import Button from '../common/Button';

const DialogBody = styled.div`
  display: flex;
  width: 602px;
  flex-flow: column;
  align-items: center;
  overflow: hidden;

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

const DialogHeader = styled.div`
  width: 100%;
  height: 46px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #b1b6bb;
  padding: 7px 13px 7px 9px;
  gap: 16px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      height: 50px;
      padding: 11px 12px 7px 8px;
    `}
`;

const HeaderIcon = styled.img`
  width: 32px;
  height: 32px;
`;

const HeaderPath = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #797e82;
  white-space: nowrap;
  overflow: hidden;
`;
const HeaderButton = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const FolderPathItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${({ isLast }) =>
    isLast &&
    css`
      pointer-events: none;
    `}
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FolderPathIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const FolderPathMoreIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const FileNavigatorWrapper = styled.div`
  width: 100%;
  flex: 1;
  overflow: hidden;
`;

const AuthDialogBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  width: 400px;
  box-sizing: border-box;
  ${noTextSelect}
`;

const AuthDialogMessage = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 16px 20px 10px 20px;
  font-size: 14px;
  color: #2f3133;
`;

const AuthFooterWrapper = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 18px 20px;
  box-sizing: border-box;
`;

const AuthButtonWapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
`;

function NaverWorksDriveDialog({
  isShow,
  from,
  navigatorType = NAVERWORKS_NAVIGATOR_TYPE.DOCUMENT
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onClickCloseBtn = () => {
    if (from === EDIT_FROM.FROM_OPENDIALOG) {
      dispatch(closeDialog());
      dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_OPEN_DOCUMENT }));
    } else {
      dispatch(closeDialog());
    }
  };
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const doFlowByCheckingResult = useDoFlowByCheckingResult();
  const getHomeURLWithProductType = useGetHomeURLWithProductType();
  const appDataSlice = useAppDataSliceSelector();
  const openNewTabWithQueryinSameDomain = useOpenNewTabWithQueryinSameDomain();
  const isPCView = isDevicePC(appDataSlice.deviceType);
  const poSDKContextState = usePOWebofficeSDKState();
  const poSDKReady = poSDKContextState.poInstance !== null;
  const whaleSpaceDataSlice = useWhaleSpaceDataSliceSelector();
  const naverWorksDataSlice = useNaverWorksDataSliceSelector();

  const [fileList, setFileList] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [folderPath, setFolderPath] = useState([
    {
      folderName: t('NaverWorksFileNavigator.NaverWorksDrive'),
      folderId: NAVERWORKS_ROOT_FOLDER_NAME
    }
  ]);
  const [isOverflow, setIsOverflow] = useState(false);
  const pathRef = useRef();
  const [isLandscape, setIsLandscape] = useState(
    window.matchMedia('(orientation: landscape)').matches
  );

  const onOpenContextMenu = (prop) => {
    dispatch(openContextMenu(prop));
  };

  const onCloseContextMenu = (prop) => {
    dispatch(closeContextMenu(prop));
  };

  const onChangeSize = useCallback(() => {
    onCloseContextMenu();
    setIsOverflow(false);
    if (window.matchMedia('(orientation: landscape)').matches) {
      setIsLandscape(true);
    } else {
      setIsLandscape(false);
    }
  }, []);

  const sendOpenDocumentGAData = (format) => {
    try {
      let label = '';
      switch (format.toLowerCase()) {
        case DOCUMENT_TYPE.HWP:
          label = '한글';
          break;
        case DOCUMENT_TYPE.SHEET:
          label = '시트';
          break;
        case DOCUMENT_TYPE.SLIDE:
          label = '슬라이드';
          break;
        case DOCUMENT_TYPE.WORD:
          label = '워드';
          break;
        default:
          label = `${format}`;
          break;
      }
      ga.event({ category: '웍스드라이브', action: '문서열기', label });
    } catch (error) {
      ga.event({ category: '웍스드라이브', action: '문서열기', label: `${format}` });
    }
  };

  const insertDriveImage = async (file, driveType, driveId, fileId) => {
    try {
      const imageBlob = new Blob([file]);
      await poSDKContextState.poInstance.handle.insertImage(imageBlob);
      ga.event({ category: '내 미디어', action: '웍스드라이브', label: '이미지추가' });
      dispatch(closeDialog());
    } catch (error) {
      alert(error.toString());
    }
  };

  const openDocument = useCallback(
    async (file, driveType, driveId, fileId) => {
      if (file) {
        const naverWorksFileInfo = {
          driveType,
          driveId,
          folderId: folderPath[folderPath.length - 1].folderId,
          fileId: fileId
        };

        doFlowByCheckingResult({
          file,
          isNaverWorksFile: true,
          naverWorksFileInfo,
          openableCallback: async (targetFile) => {
            if (poSDKReady) {
              const docinfo = {
                name: targetFile.name,
                blob: targetFile
              };

              await saveFile({
                state: indexedDBState,
                dispatch: indexedDBDispatch,
                file: targetFile,
                isNaverWorksFile: true,
                naverWorksFileInfo
              });

              sendOpenDocumentGAData(getFileFormat(targetFile.name));

              if (from === EDIT_FROM.FROM_OPENDIALOG) {
                poSDKContextState.poInstance.handle
                  .openDocument(docinfo)
                  .then(() => {
                    if (poSDKContextState.poInstance.handle.getViewMode() === PO_EDIT_MODE.READ) {
                      //Open Read Only
                      dispatch(setEditMode(PO_EDIT_MODE.READ));
                    }
                    dispatch(setFileName(targetFile.name));
                    dispatch(setNaverWorksFileInfo(naverWorksFileInfo));
                    ga.event({
                      category: '문서열기',
                      action: '문서포맷',
                      label: getExtension(targetFile.name).toLowerCase()
                    });
                  })
                  .catch((err) => {
                    ga.event({
                      category: '예외 케이스',
                      action: '열람실패_미지원',
                      label: `엔진(${err.errorCode})`
                    });
                    err.closeDialog.then(() =>
                      window.open(
                        getHomeURLWithProductType(
                          DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()
                        ),
                        '_self',
                        'noopener,noreferrer'
                      )
                    );
                  });
              } else {
                openNewTabWithQueryinSameDomain(QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC);
              }

              dispatch(closeDialog());
            }
          }
        });
      }
    },
    [folderPath]
  );

  const sendGAData = (isfrom) => {
    if (isfrom === EDIT_FROM.FROM_OPENDIALOG) {
      ga.event({ category: '웍스드라이브', action: '드라이브팝업', label: '시작화면' });
    } else if (isfrom === EDIT_FROM.FROM_FILEMENU) {
      ga.event({ category: '웍스드라이브', action: '드라이브팝업', label: '파일탭' });
    } else {
      ga.event({ category: '웍스드라이브', action: '드라이브팝업', label: `${isfrom}` });
    }
  };

  useEffect(() => {
    sendGAData(from);
    window.addEventListener('resize', onChangeSize);
    return () => {
      window.removeEventListener('resize', onChangeSize);
    };
  }, []);

  useLayoutEffect(() => {
    if (pathRef && pathRef.current) {
      if (pathRef.current.scrollWidth > pathRef.current.clientWidth) {
        setIsOverflow(true);
      } else {
        setIsOverflow(false);
      }
    } else {
      setIsOverflow(false);
    }
  }, [pathRef, folderPath, isLandscape]);

  useEffect(() => {
    setIsComplete(false);
    getNaverWorksRootFolder()
      .then((res) => {
        setFileList(
          res?.map((item) => {
            return {
              fileName: item.fileName,
              modifiedTime: item.modifiedTime,
              fileSize: item.fileSize,
              fileType: item.fileType,
              fileId: item.fileId
            };
          }) || []
        );
      })
      .catch((error) => {
        if (error instanceof NaverWorksError && error.code === 401) {
          dispatch(initNaverWorksData());
          if (navigatorType !== NAVERWORKS_NAVIGATOR_TYPE.IMAGE) {
            reauthorizationNaverWorks({ domain: whaleSpaceDataSlice.domain, isSelf: true });
          }
        } else {
          setFileList([]);
        }
      })
      .finally(() => setIsComplete(true));
  }, []);

  const reTryAuth = async () => {
    let timer = undefined;
    try {
      setIsComplete(false);
      const reauthUrl = getReauthorizationUrl({ domain: whaleSpaceDataSlice.domain });
      const winowsAuth = window.open(reauthUrl, '_blank');
      timer = setInterval(async function () {
        if (winowsAuth === null) {
          clearInterval(timer);
        } else if (winowsAuth && winowsAuth.closed) {
          clearInterval(timer);
          try {
            const res = await getNaverWorksTokenInfo();
            dispatch(
              setNaverWorksData({
                userFullName: `${res.data.userInfo.userName.lastName} ${res.data.userInfo.userName.firstName}`,
                userEmail: res.data.userInfo.email
              })
            );

            const rootInfo = await getNaverWorksRootFolder();
            setFileList(
              rootInfo?.map((item) => {
                return {
                  fileName: item.fileName,
                  modifiedTime: item.modifiedTime,
                  fileSize: item.fileSize,
                  fileType: item.fileType,
                  fileId: item.fileId
                };
              }) || []
            );
          } catch (error) {
            dispatch(initNaverWorksData());
            alert('Reauthorization Fail.');
          }
        }
      }, CONSTANT.AUTH_CHECK_TIMER);
    } catch (e) {
      if (timer) clearInterval(timer);
    } finally {
      setIsComplete(true);
    }
  };

  const getRootFolderInfo = async () => {
    try {
      const res = await getNaverWorksRootFolder();
      setFolderPath(folderPath.slice(0, 1));
      setFileList(
        res?.map((item) => {
          return {
            fileName: item.fileName,
            modifiedTime: item.modifiedTime,
            fileSize: item.fileSize,
            fileType: item.fileType,
            fileId: item.fileId
          };
        }) || []
      );
    } catch (error) {
      setFileList([]);
    } finally {
      setIsComplete(true);
    }
  };

  const onClickFolder = (type, driveId, folderId, folderName) => {
    setIsOverflow(false);
    setIsComplete(false);
    const filteringPath = folderPath.filter((item) => item.folderId === folderId);
    if (!filteringPath || filteringPath.length === 0) {
      setFolderPath([...folderPath, { folderName: folderName, folderId: folderId }]);
    } else {
      const index = folderPath.findIndex((item) => item.folderId === folderId);
      if (index >= 0) {
        setFolderPath(folderPath.slice(0, index + 1));
      }
    }
    if (folderId === NAVERWORKS_ROOT_FOLDER_NAME) {
      getRootFolderInfo();
    } else {
      getNaverWorksFolderChildren(type, driveId, folderId)
        .then((res) => {
          setFileList(
            res?.map((item) => {
              return {
                fileName: item.fileName,
                modifiedTime: item.modifiedTime,
                fileSize: item.fileSize,
                fileType: item.fileType,
                fileId: item.fileId
              };
            }) || []
          );
        })
        .catch(() => setFileList([]))
        .finally(() => {
          setIsComplete(true);
        });
    }
  };

  const refreshFolder = () => {
    setIsComplete(false);
    const lastItem = folderPath[folderPath.length - 1];
    if (lastItem) {
      if (lastItem.folderId === NAVERWORKS_ROOT_FOLDER_NAME) {
        getRootFolderInfo();
      } else {
        getNaverWorksFolderChildren(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', lastItem.folderId)
          .then((res) => {
            setFileList(
              res?.map((item) => {
                return {
                  fileName: item.fileName,
                  modifiedTime: item.modifiedTime,
                  fileSize: item.fileSize,
                  fileType: item.fileType,
                  fileId: item.fileId
                };
              }) || []
            );
          })
          .catch(() => getRootFolderInfo())
          .finally(() => {
            setIsComplete(true);
          });
      }
    } else {
      alert('Error!!');
      getRootFolderInfo();
    }
  };

  const getOverflowFolderPath = (path) => {
    const firstItem = path[0];
    const lastItem = path[path.length - 1];
    return (
      <>
        <FolderPathItem
          onClick={() =>
            onClickFolder(
              NAVERWORKS_DRIVE_TYPE.PERSONAL,
              'me',
              firstItem.folderId,
              firstItem.folderName
            )
          }>
          {firstItem.folderName}
        </FolderPathItem>
        <IconWrapper>
          <FolderPathIcon src={IconPath} srcSet={IconPath2X} />
        </IconWrapper>

        <FolderPathItem
          onClick={(event) => {
            event.stopPropagation();
            const rect = event.currentTarget.getBoundingClientRect();
            onOpenContextMenu({
              x: rect.left,
              y: rect.bottom,
              submenu: [
                <ContextMenuFolderPath
                  paths={folderPath.slice(1, -1)}
                  onClick={onClickFolder}
                  isMobile={isPCView === false}
                />
              ],
              onClickBlanket: onCloseContextMenu
            });
          }}>
          <FolderPathMoreIcon src={IconMore} srcSet={IconMore2X} />
        </FolderPathItem>
        <IconWrapper>
          <FolderPathIcon src={IconPath} srcSet={IconPath2X} />
        </IconWrapper>

        <FolderPathItem
          isLast={true}
          onClick={() =>
            onClickFolder(
              NAVERWORKS_DRIVE_TYPE.PERSONAL,
              'me',
              lastItem.folderId,
              lastItem.folderName
            )
          }>
          {lastItem.folderName}
        </FolderPathItem>
      </>
    );
  };

  return (
    <Fragment>
      {!naverWorksDataSlice.isConnected && navigatorType === NAVERWORKS_NAVIGATOR_TYPE.IMAGE ? (
        <Dialog
          icon={IconNaverWorks}
          icon2x={IconNaverWorks2X}
          title={t('ExtStorageTab.NaverDriveImage')}
          showTitleSeperateLine={true}
          showCloseBtn
          onClickCloseBtn={() => dispatch(closeDialog())}
          isShow={isShow}>
          <AuthDialogBody>
            <AuthDialogMessage>
              <Trans i18nKey="ExtStorageTab.InsertNWImageDescriptionWithAuth"></Trans>
            </AuthDialogMessage>
            <AuthFooterWrapper>
              <AuthButtonWapper>
                <Button
                  autoFocus={true}
                  cssExt={css`
                    font-size: 13px;
                    font-weight: 700;
                    background: #1d7ff9;
                    border-radius: 2px;
                    color: #fff;
                    border: none;
                    width: 81px;
                    height: 30px;
                    margin-right: 12px;
                    &:hover {
                      background: #0b8793;
                      opacity: 0.4;
                      cursor: pointer;
                    }
                  `}
                  onClick={reTryAuth}>
                  {t('ActiveLink.Connect')}
                </Button>
                <Button
                  cssExt={css`
                    font-size: 13px;
                    border-radius: 2px;
                    color: #2f3133;
                    border: 1px solid #b1b6bb;
                    width: 81px;
                    height: 30px;
                  `}
                  onClick={() => dispatch(closeDialog())}>
                  {t('Common.Cancel')}
                </Button>
              </AuthButtonWapper>
            </AuthFooterWrapper>
          </AuthDialogBody>
        </Dialog>
      ) : (
        <Dialog isShow={isShow} isNoHeader isFullScreen={isPCView === false}>
          <DialogBody isMobile={isPCView === false}>
            <DialogHeader>
              <HeaderIcon src={IconNaverWorks} srcSet={IconNaverWorks2X} />
              <HeaderPath ref={pathRef}>
                {isOverflow ? (
                  <>{getOverflowFolderPath(folderPath)}</>
                ) : (
                  <>
                    {folderPath.map((item, index, array) => (
                      <Fragment key={item.folderId}>
                        {index > 0 && (
                          <IconWrapper>
                            <FolderPathIcon src={IconPath} srcSet={IconPath2X} />
                          </IconWrapper>
                        )}
                        <FolderPathItem
                          isLast={index === array.length - 1}
                          onClick={() =>
                            onClickFolder(
                              NAVERWORKS_DRIVE_TYPE.PERSONAL,
                              'me',
                              item.folderId,
                              item.folderName
                            )
                          }>
                          {item.folderName}
                        </FolderPathItem>
                      </Fragment>
                    ))}
                  </>
                )}
              </HeaderPath>
              <HeaderButton src={IconRefresh} srcSet={IconRefresh2X} onClick={refreshFolder} />
              <HeaderButton src={closeBtnImg} onClick={onClickCloseBtn} />
            </DialogHeader>
            <FileNavigatorWrapper>
              <NaverWorksFileNavigator
                isComplete={isComplete}
                fileList={fileList}
                onClickFolder={onClickFolder}
                onClickFile={
                  navigatorType === NAVERWORKS_NAVIGATOR_TYPE.IMAGE
                    ? insertDriveImage
                    : openDocument
                }
                navigatorType={navigatorType}
              />
            </FileNavigatorWrapper>
          </DialogBody>
        </Dialog>
      )}
    </Fragment>
  );
}

export default NaverWorksDriveDialog;
